// @ts-nocheck

import palette from '../palette';

export const BurgerMenu = {
  backgroundColor: palette.bluegrey925,
  Button: {
    before: {
      backgroundColor: palette.bluegrey850,
    },
    after: {
      backgroundColor: palette.transparent,
    },
    odd: {
      backgroundGradient: palette.menuburger,
    },
    even: {
      backgroundGradient: palette.menuburgeractive,
    },
    borderColor: palette.neutralgrey700,
  },
  Label: {
    color: palette.white,
  },
  LiveBadge: {
    backgroundColor: palette.yellowwinamax450,
    color: palette.black,
  },
};
